<template>

</template>

<script>
  export default {
    name: "test"
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test.vue